import api from "./api";

const universityService = {
  getAllUniversities: async (params = {}) => {
    const response = await api.get("/api/college/universities", { params });
    return response.data.data || response.data;
  },

  getUniversityById: async (id) => {
    const response = await api.get(`/api/college/universities/${id}`);
    return response.data.data || response.data;
  },

  createUniversity: async (formData) => {
    const response = await api.post("/api/college/universities", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.data || response.data;
  },

  updateUniversity: async (id, formData) => {
    const response = await api.put(`/api/college/universities/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.data || response.data;
  },

  deleteUniversity: async (id) => {
    const response = await api.delete(`/api/college/universities/${id}`);
    return response.data.data || response.data;
  },
};

export default universityService;
